import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { STRING_ACCESS_TOKEN_CHECKLIST, STRING_ID_EMPRESA_CHECKLIST, STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST, STRING_TIPO_USUARIO_CHECKLIST } from "../utils/const/string-const";

export default function Salir() {
  const history = useHistory();
  const clearData = (page, params) => {
    try {
      // console.log('clearData');
      if (params !== undefined && params !== null) {
        if (params.acciones !== undefined) {
          delete params.acciones;
        }
        history.push({
          pathname: `${page}`,
          state: params,
        });
        // history.push(`/`);
      } else {
        history.push(`${page}`);
        // history.push(`/`);
      }
      // console.log('end clearData');
    } catch (e) {
      console.error(e.message);
    }
  };

  useEffect(() => {
    // console.log('useEffect');
    localStorage.clear(STRING_ID_EMPRESA_CHECKLIST);
    localStorage.clear(STRING_ACCESS_TOKEN_CHECKLIST);
    localStorage.clear(STRING_TIPO_USUARIO_CHECKLIST);
    localStorage.clear(STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST);
    clearData("login");
    // console.log('end useEffect');
  }, []);

  return <div className="p-[2rem]"></div>;
}
